import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { projectSettingsQuery } from "@/lib/api/queries";
import { projectSearch } from "@/lib/search";

export const Route = createFileRoute("/w/$workspace/p/$project/settings")({
  validateSearch: projectSearch.extend({
    tab: z.enum(["general", "members", "notifications", "tokens", "danger"]).optional(),
  }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(projectSettingsQuery(params.workspace, params.project)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const { tab } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <SettingsPage
        workspace={workspace}
        project={project}
        tab={tab ?? "general"}
        onTab={(t) =>
          navigate({
            search: (prev) => ({ env: prev.env, tab: t === "general" ? undefined : t }),
            replace: true,
          })
        }
      />
    );
  },
});
